/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @typedef {Object} ResultDataValue
 * @property {String} value The unique id of the value
 * @property {String} label The label of the value
 * @property {String} type The type of the value
 */

/**
  * @typedef {Object} QueryDataItemCommand
  * @private
  * @property {String} name The name of the query command
  * @property {String[]} membersIds The array of Member Unique Names
  * @property {Number} [limit=51] The limit of the selection (default: 51)
  */
